import { render, staticRenderFns } from "./CustomerOrderTemplate.vue?vue&type=template&id=5c12d9cf&scoped=true&"
import script from "./CustomerOrderTemplate.vue?vue&type=script&lang=js&"
export * from "./CustomerOrderTemplate.vue?vue&type=script&lang=js&"
import style0 from "./CustomerOrderTemplate.vue?vue&type=style&index=0&id=5c12d9cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c12d9cf",
  null
  
)

export default component.exports